import { RoutePathsEnum } from "infrastructure/RoutePathsEnum";
import { GlobalState } from "little-state-machine";

export const updateEditItemOrderPageOrigination = (
  state: GlobalState,
  editItemOrderPageOrigination : RoutePathsEnum
) => ({
  ...state,
  editItemOrderPageOrigination
});
